import React from 'react';
import {
  Box,
  Button,
  Typography,
  IconButton
} from '@mui/material';
import {
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon
} from '@mui/icons-material';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
  totalItems: number;
  onPageChange: (page: number) => void;
}

export const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  hasNext,
  hasPrevious,
  totalItems,
  onPageChange
}) => {
  const handlePrevious = () => {
    if (hasPrevious) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (hasNext) {
      onPageChange(currentPage + 1);
    }
  };

  // Show pagination if there are items, even if only 1 page
  if (totalItems === 0) {
    return null;
  }

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      p={2}
      borderTop={1}
      borderColor="divider"
    >
      <Typography variant="body2" color="text.secondary">
        Showing {((currentPage - 1) * 10) + 1} to {Math.min(currentPage * 10, totalItems)} of {totalItems} items
      </Typography>
      
      <Box display="flex" alignItems="center" gap={1}>
        <IconButton
          onClick={handlePrevious}
          disabled={!hasPrevious}
          size="small"
        >
          <ChevronLeftIcon />
        </IconButton>
        
        <Typography variant="body2">
          Page {currentPage} of {totalPages}
        </Typography>
        
        <IconButton
          onClick={handleNext}
          disabled={!hasNext}
          size="small"
        >
          <ChevronRightIcon />
        </IconButton>
      </Box>
    </Box>
  );
}; 